import React from 'react';
import PropTypes from 'prop-types';
import prodSpecs from 'lib/nav-product-specs';
import environment from 'lib/environment';

const RenderProductLink = (props) => {
  const prod = prodSpecs[props.product];
  if (prod) {
    const prodName = prod.product;
    const prodClass = prod.class;
    const prodUrl = environment.get()[prod.productUrlRef];
    return (
      <li id={`${prodName}_li`}>
        <a href={prodUrl} id={`${prodName}-nav`} tabIndex="-1">
          <i className={`${prodClass}`} />
          {prodName}
        </a>
      </li>
    );
  }
  return null;
};

RenderProductLink.propTypes = {
  product: PropTypes.string.isRequired,
};

export default RenderProductLink;
